module.exports = __webpack_public_path__ + "static/media/investor-report-background.80029e2c.webp";